(() => {
  const requiredValidationHandlerKey = Symbol.for(
    "xileProductOptions.legacyRequiredValidationHandler",
  );
  const loadingCountKey = Symbol.for("xileProductOptions.legacyLoadingCount");
  const requiredOptionsAttribute = "data-xile-required-options-cart";
  const loadingAttribute = "data-xile-required-options-loading";
  const acceleratedCheckoutStyleId = "xile-product-options-accelerated-checkout-style";

  ensureAcceleratedCheckoutStyles();
  const blocks = document.querySelectorAll("[data-proxy-path][data-product-id]");

  blocks.forEach((block) => {
    loadOptions(block).catch(() => {});
  });

  async function loadOptions(block) {
    const productId = block.getAttribute("data-product-id");
    const proxyPath = block.getAttribute("data-proxy-path");

    if (!productId || !proxyPath) return;

    const form = findProductForm(block);
    if (!form) return;

    beginOptionLoading(form);

    try {
      const url = new URL(proxyPath, window.location.origin);
      url.searchParams.set("product_id", productId);

      const response = await fetch(url.toString(), {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        renderOptions(block, form, getFallbackOptions(block));
        return;
      }

      const payload = await response.json();
      const optionSets = payload.optionSets?.length
        ? payload.optionSets
        : getFallbackOptions(block);

      renderOptions(block, form, optionSets);
    } catch {
      renderOptions(block, form, getFallbackOptions(block));
    } finally {
      finishOptionLoading(form);
    }
  }

  function ensureAcceleratedCheckoutStyles() {
    if (document.getElementById(acceleratedCheckoutStyleId)) return;

    const style = document.createElement("style");
    style.id = acceleratedCheckoutStyleId;
    style.textContent = [
      "form[data-xile-required-options-loading] .shopify-payment-button",
      "form[data-xile-required-options-loading] .shopify-payment-button__button",
      "form[data-xile-required-options-loading] .shopify-payment-button__more-options",
      "form[data-xile-required-options-loading] shopify-accelerated-checkout",
      "form[data-xile-required-options-loading] [data-shopify=\"payment-button\"]",
      "form[data-xile-required-options-loading] [data-shopify=\"accelerated-checkout\"]",
      "form[data-xile-required-options-cart] .shopify-payment-button",
      "form[data-xile-required-options-cart] .shopify-payment-button__button",
      "form[data-xile-required-options-cart] .shopify-payment-button__more-options",
      "form[data-xile-required-options-cart] shopify-accelerated-checkout",
      "form[data-xile-required-options-cart] [data-shopify=\"payment-button\"]",
      "form[data-xile-required-options-cart] [data-shopify=\"accelerated-checkout\"]",
    ].join(",\n") + " { display: none !important; }";
    (document.head || document.documentElement).append(style);
  }

  function beginOptionLoading(form) {
    form[loadingCountKey] = (form[loadingCountKey] || 0) + 1;
    form.setAttribute(loadingAttribute, "");
  }

  function finishOptionLoading(form) {
    const loadingCount = Math.max((form[loadingCountKey] || 1) - 1, 0);

    form[loadingCountKey] = loadingCount;
    if (loadingCount === 0) form.removeAttribute(loadingAttribute);
    syncRequiredOptionVisibility(form);
  }

  function syncRequiredOptionVisibility(form) {
    const hasRequiredOption = [...form.elements].some((element) =>
      element.matches("select[data-xile-option][required]"),
    );

    form.toggleAttribute(requiredOptionsAttribute, hasRequiredOption);
  }

  function findProductForm(block) {
    const section = block.closest("section, .shopify-section") || document;

    return (
      section.querySelector(
        'form[action*="/cart/add"]:not([class*="installment"]):not([id*="installment"])',
      ) ||
      document.querySelector(
        'form[action*="/cart/add"]:not([class*="installment"]):not([id*="installment"])',
      ) ||
      section.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function renderOptions(block, form, optionSets) {
    if (!form) return;

    if (!form[requiredValidationHandlerKey]) {
      const handler = (event) => {
        const invalid = [...form.elements].find(
          (control) =>
            control.matches("select[data-xile-option][required]") &&
            !control.checkValidity(),
        );
        if (!invalid) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        invalid.reportValidity();
        invalid.focus();
      };
      form.addEventListener("submit", handler, true);
      form[requiredValidationHandlerKey] = handler;
    }

    const status = block.querySelector(".xile-product-options__status");
    block
      .querySelectorAll(".xile-product-options__field")
      .forEach((field) => field.remove());

    if (!optionSets.length) {
      syncRequiredOptionVisibility(form);
      if (status) status.textContent = "";
      return;
    }

    let formId = form.getAttribute("id");
    if (!formId) {
      formId = `xile-product-form-${Date.now()}`;
      form.setAttribute("id", formId);
    }

    optionSets.forEach((optionSet) => {
      const field = document.createElement("div");
      field.className =
        "product-form__input product-form__input--dropdown xile-product-options__field";

      const label = document.createElement("label");
      const id = `xile-option-${optionSet.id}`;
      label.className = "form__label";
      label.setAttribute("for", id);
      label.textContent = optionSet.title;

      const selectWrap = document.createElement("div");
      selectWrap.className = "select";

      const select = document.createElement("select");
      select.className = "select__select";
      select.dataset.xileOption = "true";
      select.id = id;
      select.name = `properties[${optionSet.propertyName}]`;
      select.setAttribute("form", formId);
      if (optionSet.required) select.required = true;

      const hasValidDefault = optionSet.defaultValue &&
        optionSet.values.some((value) => value.value === optionSet.defaultValue);
      if (!optionSet.required || !hasValidDefault) {
        const placeholder = new Option(
          optionSet.required ? "-- Please select --" : "No selection", "", true, true,
        );
        placeholder.disabled = Boolean(optionSet.required);
        select.append(placeholder);
      }

      optionSet.values.forEach((value) => {
        select.append(new Option(value.label, value.value));
      });

      if (
        optionSet.defaultValue &&
        [...select.options].some((option) => option.value === optionSet.defaultValue)
      ) {
        select.value = optionSet.defaultValue;
      }

      selectWrap.append(select);
      selectWrap.append(createCaretIcon());
      field.append(label, selectWrap);
      block.insertBefore(field, status || null);
    });

    if (status) status.textContent = "";
    syncRequiredOptionVisibility(form);
  }

  function createCaretIcon() {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");

    svg.setAttribute("class", "icon icon-caret");
    svg.setAttribute("viewBox", "0 0 10 6");
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    path.setAttribute("fill-rule", "evenodd");
    path.setAttribute(
      "d",
      "M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 1 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708",
    );
    svg.append(path);

    return svg;
  }

  function getFallbackOptions(block) {
    const title = block.getAttribute("data-fallback-title") || "";
    const propertyName = block.getAttribute("data-fallback-property") || "";
    const rawValues = block.getAttribute("data-fallback-values") || "";
    const required = block.getAttribute("data-fallback-required") === "true";
    const values = rawValues
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => {
        const [label, value] = line.split("|").map((part) => part.trim());

        return { label, value: value || label };
      });

    if (!title || !propertyName || values.length === 0) return [];

    return [
      {
        id: "fallback",
        title,
        propertyName,
        required,
        defaultValue: "",
        values,
      },
    ];
  }
})();
